(($, window, document, undefined) => {
  $(() => {

    const onToggleMobileFilter = () => {
      $('.search-filters__filters .btn-outline-primary').on('click', function () {
        $('aside.layout-sidebar-first').find('.search-sidebar').addClass('show');
      });

      $('.search-sidebar__close').on('click', function () {
        $('aside.layout-sidebar-first').find('.search-sidebar').removeClass('show');
      });
    }

    onToggleMobileFilter()

  });
})(window['jQuery'], window, document);
